module.exports = __webpack_public_path__ + "static/media/perpertualsuccour.3f178647.webp";